import React, { Component } from 'react';

const InlineError = function(props) {
    let errorName = (props && props.error && props.error.friendly && props.error.friendly.name) ? props.error.friendly.name : 'Unknown Error';
    let errorDesc = (props && props.error && props.error.friendly && props.error.friendly.description) ? props.error.friendly.description : 'An unknown error occured and was not properly handled.';
    let closeFunction = props.closeFunction ? props.closeFunction : () => {document.location.reload()};
    let closeText = props.closeText ? props.closeText : 'Refresh Page';
    let allErrors = [];
    if(props.error.errors) {
        for (const key in props.error.errors) {
            if (props.error.errors.hasOwnProperty(key)) {
                const err = props.error.errors[key];
                err.forEach( (val, ind, arr) => {
                    allErrors.push(val);
                })
            }
        }
    }

    return (
        <div role='alert' className='alert alert-danger col'>
            <h4 className="alert-heading">{errorName}</h4>
            <hr/>
            <p className="mb-1">{errorDesc}</p>
            <br/>
            {allErrors.map( (val, ind, arr) => {
                return <p key={ind} className="mb-1">{val}</p>
            })}
            <div className="container text-center">
                <a onClick={closeFunction} className="btn btn-accent">{closeText}</a>
            </div>
        </div>
    )
};

export default InlineError;